import { render, staticRenderFns } from "./Evaluations.vue?vue&type=template&id=0dc4365a&scoped=true&"
import script from "./Evaluations.vue?vue&type=script&lang=js&"
export * from "./Evaluations.vue?vue&type=script&lang=js&"
import style0 from "./Evaluations.vue?vue&type=style&index=0&id=0dc4365a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc4365a",
  null
  
)

export default component.exports